import React, { Component, useState, useEffect, Fragment } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import Loader from '../common/loaderapp';
import axios from 'axios';

const FormquestionEdit = () => {
    let navigate = useNavigate();
    const { id } = useParams();
    const [load, setLoad] = useState(true);
    const [formquestion, setFormquestion] = useState({ NAME_HAQ:'', LAST_NAME_HAQ:'', PHONE_NUMBER_HAQ:'', EMAIL_HAQ:'', WRITE_US_HAQ:''})
    const [key, setKey] = useState(0); 
    const [file, setFile] = useState(null);

    useEffect(() => {
        if(id != 0){
            fetch('/p_contact_form', {
                method: 'PATCH',
                body: JSON.stringify({id}),
                headers: {'Content-Type': 'application/json'}
            })
            .then(res => res.json())
            .then(res => {
				console.log('El speaker',res);
                if(res.length != 0){
                    const { NAME_HAQ, LAST_NAME_HAQ, PHONE_NUMBER_HAQ, EMAIL_HAQ, WRITE_US_HAQ} = res[0];
                    setFormquestion({ NAME_HAQ, LAST_NAME_HAQ, PHONE_NUMBER_HAQ, EMAIL_HAQ, WRITE_US_HAQ })
                }
            })
            .catch(err => console.log('Error: '+err))
        }
        setLoad(false);
    }, [])

    const { formquestion_name, company, bio, picture } = formquestion
    const actFormquestions=(e)=>setFormquestion({ ...formquestion, [e.target.name]:(e.target.value)})
    
    function setInfo() {
        fetch('/p_speaker', {
            method: id != 0 ? 'PUT' : 'POST',
            body: JSON.stringify({...formquestion,id}),
            headers: {'Content-Type': 'application/json'}
        })
        .then(res => res.json())
        .then(res => {
            console.log('El formquestion',res);
            navigate('/formquestion')
        })
        .catch(err => console.log('Error: '+err))
    }

    const handleFileChange = (event) => {
        console.log('FILE',event.target.files[0]);
        const selectedFile = event.target.files[0];
        if (selectedFile && !/^image\//.test(selectedFile.type)) {
            console.error('Invalid file type. Only images are allowed.');
            setKey((prevKey) => prevKey + 1);
            setFile(null);
        } else {
            setFormquestion({ ...formquestion, 'picture':selectedFile.name})
            setFile(selectedFile);
        }
    };

    const handleUpload = async () => {
        if (file) {
            const formData = new FormData();
            formData.append('file', file);
            try {
                const response = await axios.post('/uploadFormquestions', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                console.log('File uploaded successfully:', response.data);
                setInfo();
            } catch (error) {
            console.error('Error uploading file:', error);
            }
        } else {
            console.error('No file selected');
        }
    };

    return (
        <Fragment>
            {load ? 
                <Loader/>: 
                <Fragment>
                    <div className="col-sm-12 mt-5 mb-5">
                        <div className="row">
                            <div className="col-sm-12 mb-2 mt-3">
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 mb-3">
                                <h5>View Question data</h5>
                                {/* <p>You can edit the name, photo and title, also you can add news or delete them.</p> */}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <div className="question-content-inf">
                                    <p className="text-inf"><span className="">First name: </span>{formquestion.NAME_HAQ}</p>
                                    <p className="text-inf"><span className="">Last name: </span>{formquestion.LAST_NAME_HAQ}</p>
                                    <p className="text-inf"><span className="">Phone number: </span>{formquestion.PHONE_NUMBER_HAQ}</p>
                                    <p className="text-inf"><span className="">Email: </span>{formquestion.EMAIL_HAQ}</p>
                                    <p className="text-inf"><span className="">Write us: </span>{formquestion.WRITE_US_HAQ}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Fragment>
            }
        </Fragment>
    );
}

export default FormquestionEdit;